/**
 * 指で操作する端末かどうか。
 *
 * スマホで「← → キー」「P キー」の説明が出ていたので、タッチ端末ではキー操作の説明を隠す。
 * `<html data-input="touch">` を立て、CSS の `.kbd-only` で消す。
 */

export function isTouchDevice(): boolean {
  try {
    return window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
  } catch {
    return false;
  }
}

/** 文字を大きくする設定（`<html data-text="large">`）。 */
export function applyTextSize(large: boolean): void {
  if (large) document.documentElement.dataset.text = 'large';
  else delete document.documentElement.dataset.text;
}

/** 動きを減らす設定（`<html data-motion="reduce">`）。CSS のアニメーションも止める。 */
export function applyMotionPreference(reduce: boolean): void {
  if (reduce) document.documentElement.dataset.motion = 'reduce';
  else delete document.documentElement.dataset.motion;
}

/**
 * 県えらびの画面など、ゲームを起動しない画面でも設定を反映するために、保存領域から直接読む。
 */
export function applyTextSizeFromStorage(settingsKey: string): void {
  try {
    const raw = localStorage.getItem(settingsKey);
    const parsed = raw ? JSON.parse(raw) : null;
    applyTextSize(Boolean(parsed && parsed.largeText === true));
    applyMotionPreference(Boolean(parsed && parsed.reduceMotion === true));
  } catch {
    // 読めなければ標準のまま
  }
}

export function applyInputMode(): void {
  document.documentElement.dataset.input = isTouchDevice() ? 'touch' : 'mouse';
}

/**
 * 保存領域の設定に「文字を大きく」を書き込み、画面にも反映する。
 * ゲームを起動しない県えらびの画面から使う（ゲーム中は StorageSystem 経由で書く）。
 */
export function setLargeTextInStorage(settingsKey: string, large: boolean): void {
  applyTextSize(large);
  try {
    const raw = localStorage.getItem(settingsKey);
    const parsed = raw ? (JSON.parse(raw) as Record<string, unknown>) : {};
    localStorage.setItem(settingsKey, JSON.stringify({ ...parsed, largeText: large }));
  } catch {
    // 保存できなくても、この画面では大きくなる
  }
}

export function isLargeText(): boolean {
  return document.documentElement.dataset.text === 'large';
}
